import React, { useEffect, useState, useRef } from 'react';
import styles from './Notification.module.css';

export function showNotification(message: string) {
  window.dispatchEvent(new CustomEvent('show-notification', { detail: message }));
}

export function NotificationRoot() {
  const [message, setMessage] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const m = (e as CustomEvent).detail as string;
      setMessage(m);

      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
      // auto-dismiss after 2 seconds
      // Make sure you increase this if you increase animation
      timerRef.current = window.setTimeout(() => setMessage(null), 2000);
    };

    window.addEventListener('show-notification', handler as EventListener);
    return () => {
      window.removeEventListener('show-notification', handler as EventListener);
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  if (!message) return null;

  return (
    <div className={styles.container} role="status" aria-live="polite">
      <div className={styles.message}>{message}</div>
    </div>
  );
}
